
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import TableSelectionView from '../../../../NewOrder/TableSelectionView'
import PagerNumberView from '../../../../NewOrder/PagerNumberView'
import { BsPhoneVibrate } from "react-icons/bs";


var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var constants = require('../../../../../utils/domain/constants.js');

class TableToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.renderTableSelection = this.renderTableSelection.bind(this);

        this.state = {};
        this.state.showTableSelectionDialogue = false;
        this.state.showPagerNumberDialogue = false;
    }

    render()
    {
        if (this.props.saleContext.sale.dispatchType == constants.DispatchTypeDineIn)
            return this.renderDineInTableAssignmentToolbarButton();

        if (this.props.saleContext.sale.dispatchType == constants.DispatchTypeTakeAway)
            return this.renderTakeAwayPagerNumberToolbarButton();

        return this.renderDisabledToolbarButton();
    }

    renderDineInTableAssignmentToolbarButton()
    {
        let saleContext = this.props.saleContext;
        let canChangeTable = saleCommonUtility.canChangeTable(saleContext);
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canChangeTable ? 1 : 0.5, color: "#787878"}}
                             onClick={(event) =>
                             {
                                event.stopPropagation();

                                if (!canChangeTable)
                                    return; 

                                this.state.showTableSelectionDialogue = true;
                                this.setState({});
                             }}>
                        <DineInIcon size="2.2vw"/>
                    </div>
                    {this.renderTableSelection()}
                </Fragment>)
    }

    renderTakeAwayPagerNumberToolbarButton()
    {
        let saleContext = this.props.saleContext;
        
        let canChangePagerNumber = saleCommonUtility.canChangePagerNumber(saleContext);
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canChangePagerNumber ? 1 : 0.5, color: "#787878"}}
                             onClick={(event) =>
                             {
                                event.stopPropagation();

                                if (!canChangePagerNumber)
                                    return; 

                                this.state.showPagerNumberDialogue = true;
                                this.setState({});
                             }}>
                        <BsPhoneVibrate size="2.2vw"/>
                    </div>
                    {this.renderPagerNumberDialogue()}
                </Fragment>)
    }

    renderDisabledToolbarButton()
    {
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:0.5, color: "#787878"}}
                            onClick={(event) =>
                            {
                                event.stopPropagation();
                                return;
                            }}>
                        <DineInIcon size="2.2vw"/>
                    </div>
                </Fragment>)
    }

    renderTableSelection()
    {
        if (!this.state.showTableSelectionDialogue)
            return null;

        return <TableSelectionView sale={this.props.saleContext.sale} mode="hosted" 
                                   onCancel={()=>
                                            {
                                                this.state.showTableSelectionDialogue = false;
                                                this.setState({});
                                            }}
                                    onDone={()=>
                                    {
                                        this.state.showTableSelectionDialogue = false;
                                        this.setState({});
                                    }}/>
    }

    renderPagerNumberDialogue()
    {
        if (!this.state.showPagerNumberDialogue)
            return null;

        return <PagerNumberView
                    onCancel={()=>
                    {
                        this.state.showPagerNumberDialogue = false;
                        this.setState({});
                    }}
                    onDone={()=>
                    {
                        this.state.showPagerNumberDialogue = false;
                        this.setState({});
                    }}
                    sale={this.props.saleContext.sale}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(TableToolbarButton)

const DineInIcon = ({size})=>{

    return(
            <svg fill="currentColor" height={size} width={size} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297"  >
                <g>
                    <path d="M181.115,236.463h-22.731V125.768h87.963c5.458,0,9.884-4.425,9.884-9.883V66.961c0-5.458-4.426-9.884-9.884-9.884H50.653
                        c-5.458,0-9.884,4.426-9.884,9.884v48.924c0,5.458,4.426,9.883,9.884,9.883h87.963v110.695h-22.731
                        c-5.459,0-9.884,4.426-9.884,9.884c0,5.458,4.425,9.884,9.884,9.884h65.23c5.458,0,9.884-4.426,9.884-9.884
                        C190.999,240.889,186.573,236.463,181.115,236.463z M60.536,76.845h175.928v29.156H60.536V76.845z"></path>
                    <path d="M0,246.347c0,5.458,4.426,9.884,9.884,9.884s9.883-4.426,9.883-9.884v-55.348h61.772v55.348
                        c0,5.458,4.426,9.884,9.884,9.884c5.458,0,9.883-4.426,9.883-9.884V148.5c0-5.458-4.425-9.884-9.883-9.884H19.767V50.653
                        c0-5.458-4.425-9.884-9.883-9.884S0,45.195,0,50.653V246.347z M19.767,158.384h61.772v12.849H19.767V158.384z"></path>
                    <path d="M195.693,246.347c0,5.458,4.426,9.884,9.884,9.884c5.458,0,9.884-4.426,9.884-9.884v-55.348h61.772v55.348
                        c0,5.458,4.425,9.884,9.883,9.884c5.458,0,9.884-4.426,9.884-9.884V50.653c0-5.458-4.426-9.884-9.884-9.884
                        c-5.458,0-9.883,4.426-9.883,9.884v87.963h-71.656c-5.458,0-9.884,4.426-9.884,9.884V246.347z M215.461,171.232v-12.849h61.772
                        v12.849H215.461z"></path>
                </g>
            </svg>
        )
}